import React, { useState } from 'react';
import { EyeTwoTone } from '@ant-design/icons';
import { Drawer, Descriptions, List, Button } from 'antd';

const ShowOverride = ({ item }) => {
  const [modelVisible, setModelVisible] = useState(false);
  const [childrenDrawerVisible, setChildrenDrawerVisible] = useState(false);
  const [childrenDrawerTitle, setChildrenDrawerTitle] = useState('');
  const [childrenDrawerContent, setChildrenDrawerContent] = useState([]);

  const showModal = () => {
    setModelVisible(true);
  };

  const hideModalCancel = () => {
    setModelVisible(false);
  };

  const showChildrenDrawer = (title, content) => {
    setChildrenDrawerTitle(title);
    setChildrenDrawerContent(content);
    setChildrenDrawerVisible(true);
  };

  const hideChildrenDrawer = () => {
    setChildrenDrawerVisible(false);
  };

  const listItemStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };

  const drawerStyle = {
    width: '70%', // Set width to a percentage for larger screens
    maxWidth: '800px', // Max width to prevent excessive expansion
  };

  return (
    <>
      <EyeTwoTone key="view" onClick={showModal} />
      <Drawer
        title={item.name}
        visible={modelVisible}
        closable={true}
        placement="right"
        onClose={hideModalCancel}
        style={drawerStyle}
        bodyStyle={{ padding: '16px', overflow: 'auto' }}
      >
        <Descriptions column={1}>
          <Descriptions.Item label="Name">{item.name}</Descriptions.Item>
          <Descriptions.Item label="Default Capabilities">
            <Button onClick={() => showChildrenDrawer('Capabilities', item.defaultCapabilities)}>
              View Capabilities
            </Button>
          </Descriptions.Item>
          <Descriptions.Item label="Default Resources">
            <Button onClick={() => showChildrenDrawer('Resources', item.defaultRessources)}>
              View Resources
            </Button>
          </Descriptions.Item>
        </Descriptions>
        <Drawer
          title={childrenDrawerTitle}
          width={320}
          closable={true}
          onClose={hideChildrenDrawer}
          visible={childrenDrawerVisible}
          bodyStyle={{ padding: '16px', overflow: 'auto' }}
        >
          <List
            size="small"
            bordered
            dataSource={childrenDrawerContent}
            renderItem={item => (
              <List.Item key={item._id} style={listItemStyle}>
                <strong>{item.name}</strong> {item.permission && `(Permission: ${item.permission})`}
              </List.Item>
            )}
          />
        </Drawer>
      </Drawer>
    </>
  );
};

export default ShowOverride;
